// JavaScript Document for everything 

	jQuery(document).ready(function() {
			var minOnepageW = 992;
			jQuery('#tshirt').fullpage({
									
				anchors: ['firstPage', 'secondPage', '3rdPage', 'fourthPage', 'fifthPage', 'sixthPage'],
				navigation: true,
				navigationPosition: 'right',

        onLeave: function (index, nextIndex, direction) {
				
			// on Leave Validate when each slider Moves 
			
            var activeSlide = jQuery('.fp-section.active');
          
		  	//Condition to check it is the 2nd Slider (1st Step of the purchase)
			if(index==2 ) { 
              if(!jQuery('input:radio[name="types[]"]').is(':checked')) {
                jQuery.fn.fullpage.setMoveStop(true);
                activeSlide.find('div.title_container').addClass('requiredtm');
                activeSlide.find('div.requiredField').show();
              }
              else {
                jQuery.fn.fullpage.setMoveStop(false);
                activeSlide.find('div.title_container').removeClass('requiredtm');
                activeSlide.find('div.requiredField').hide();
              }
            }
          
		  
		  //Condition to check it is the 3rd Slider (2nd Step of the purchase)
           if(index==3) {  
              if(!jQuery('input:radio[name="style[]"]').is(':checked')) {
                jQuery.fn.fullpage.setMoveStop(true);
                activeSlide.find('div.title_container').addClass('requiredtm');
                activeSlide.find('div.requiredField').show();
              }
              else {
                jQuery.fn.fullpage.setMoveStop(false);
                activeSlide.find('div.title_container').removeClass('requiredtm');
                activeSlide.find('div.requiredField').hide();
              }
            } 
            
			//Condition to check it is the 4th Slider (3rd Step of the purchase)
            if(index==4) {
              if(!jQuery('input:radio[name="color[]"]').is(':checked')) {
                jQuery.fn.fullpage.setMoveStop(true);
                activeSlide.find('div.title_container').addClass('requiredtm');
                activeSlide.find('div.requiredField').show();
              }
              else {
                jQuery.fn.fullpage.setMoveStop(false);
                activeSlide.find('div.title_container').removeClass('requiredtm');
                activeSlide.find('div.requiredField').hide();
              }
              
            }
          
		  //Condition to check it is the 5th Slider (4th Step of the purchase)
           if(index==5) {
               jQuery('input:checkbox[name="initials[]"]').each(function(){
                  if(jQuery(this).is(':checked')){
                    var textID = jQuery(this).parent().parent().parent().find('.txtBoxinitial').find('input').attr("id");
                    if(textID=='initialFront'){
                       var texVal = jQuery('#txtInitial_front').val();  // Don't confuse this with the name of Text field id. I have mentioned this id as "txtInitial_front" But this one is for the back side initial on the T-Shirt.
					   // validate wether or not the back side initial text box is filled
                       if(texVal=='') {
                        jQuery.fn.fullpage.setMoveStop(true);
                        activeSlide.find('div.title_container').addClass('requiredtm');
                        activeSlide.find('div.requiredField').show();
                        jQuery('#txtInitial_front').focus();
                       }
                      else {
                        activeSlide.find('div.title_container').removeClass('requiredtm');
                        activeSlide.find('div.requiredField').hide(); 
                      }
                    }
					// validate wether or not the side hand initial text box is filled.
                    if(textID=='initialBack'){
                      var texVal = jQuery('#txtInitial_back').val();
                      if(texVal=='') {
                        jQuery.fn.fullpage.setMoveStop(true);
                        activeSlide.find('div.title_container').addClass('requiredtm');
                        activeSlide.find('div.requiredField').show();
                        jQuery('#txtInitial_back').focus();
                      }
                      else {
                        activeSlide.find('div.title_container').removeClass('requiredtm');
                        activeSlide.find('div.requiredField').hide();
                      }
                    }
                  }
              });
           }
          
        },      
		afterLoad: function(anchorLink, index){   // This function is for after loading validation. Incase the customer directly goes to the specific slider by URL HASH tag.
			 // After the Text 
			  if(index==1) {
				jQuery('#fp-nav').hide(); 
			  }
			  else {
				jQuery('#fp-nav').show(); 
			  }
         	
		 	
			// Validate if Slider 2(T-Shirt Type 1st Step on purchase) Type checkbox is checked or not.
            if(index==3) { 
              if(!jQuery('input:radio[name="types[]"]').is(':checked')) {
                jQuery.fn.fullpage.moveTo(index-1);
              }
            }
          	// Validate if Slider 3(T-Shirt Style) Style checkbox is checked or not.
          	if(index==4) {  
              if(!jQuery('input:radio[name="style[]"]').is(':checked')) {
                jQuery.fn.fullpage.moveTo(index-1);
              }
            } 
            // Validate if Slider 4(T-Shirt Types and Colours) Style checkbox is checked or not.
            if(index==5) {
              if(!jQuery('input:radio[name="types[]"]').is(':checked')) {
                jQuery.fn.fullpage.moveTo(2);
              } 
              if(!jQuery('input:radio[name="color[]"]').is(':checked')) {
                jQuery.fn.fullpage.moveTo(index-1);
              }
            }
           // Validate if Slider 2(T-Shirt Type 1st Step on purchase) Type checkbox is checked or not.
           if(index==6) {  
             if(!jQuery('input:radio[name="types[]"]').is(':checked')) {
                jQuery.fn.fullpage.moveTo(2);
             }
             
			 // Check if initals check box has a filled in value on the text box
		   jQuery('input:checkbox[name="initials[]"]').each(function(){
			  if(jQuery(this).is(':checked')){
				var textID = jQuery(this).parent().parent().parent().find('.txtBoxinitial').find('input').attr("id");
				if(textID=='initialFront'){
				   var texVal = jQuery('#txtInitial_front').val();
				   if(texVal=='') {
					jQuery.fn.fullpage.moveTo(index-1);
					jQuery('#txtInitial_front').focus();
				   }
				}
				if(textID=='initialBack'){
				  var texVal = jQuery('#txtInitial_back').val();
				  if(texVal=='') {
					jQuery.fn.fullpage.moveTo(index-1);
					jQuery('#txtInitial_back').focus();
				  }
				}
				
				
			  }
			});
            
             
            }
           
          
			if(jQuery(window).width() >= minOnepageW){
				var footer = jQuery('.footer');
				var footerH = footer.height();
				var speed = 600;
				
				// When the slider moves, show the footer box to the customer. Now it is customized as "Popup" after the customer has selected the Size.
				/*if(index != 1){
					if(!footer.hasClass('active')){
						footer.animate({'bottom': '0px'}, speed);
						footer.addClass('active');
					}
				}else{
					if(footer.hasClass('active')){
						footer.animate({'bottom': (-footerH) + 'px'}, speed);
						footer.removeClass('active');
					}
				}*/
			}
			
			
			}
		});
			
			
		/*jQuery(window).scroll(function(){
		if(jQuery(window).width() < minOnepageW){
			var footer = jQuery('.footer');
			var footerH = footer.height();
			var speed = 300;
			var marker = jQuery('.watch-intro').height(); // y pos where to show/hide footer
			if(jQuery(window).scrollTop() >= (marker / 2)){
				if(!footer.hasClass('active')){
					footer.addClass('active').animate({'bottom': '0px'}, speed);
				}
			} else {
				if(footer.hasClass('active')){
					footer.removeClass('active').animate({'bottom': (-footerH) + 'px'}, speed);
				}
			}
		}
	});*/

			
			
	//scroll page when down arrow is clicked
	jQuery('.more').on('click', function(e){
		var idx = jQuery(this).data('index');
		if(idx){
			e.preventDefault();
			jQuery('main').moveTo(idx);
		}
	});
			

	//limit number of checked options
	jQuery('.limit-checkboxes').on('click', 'label', function(){
		var parent = jQuery(this).closest('section');
		var maxOptions = jQuery(this).closest('.limit-checkboxes').data('max-checkboxes') | 0;
		var selectedOptions = jQuery(this).closest('.limit-checkboxes').find('input').filter(function(){
			return jQuery(this).prop('checked') == true
		}).length;
		var isChecked = jQuery(this).siblings('input').prop('checked');
		if(maxOptions > 0 && selectedOptions == maxOptions && !isChecked){
			if(parent.data('last-checked')){
				var lastChecked = parent.data('last-checked');
				lastChecked.siblings('input').prop('checked', false);
			}
			else{
				return false;
			}
		}
		parent.data('last-checked', jQuery(this));
	});

	//show/hide info box
	var infoBox =   jQuery('.watch-info');
	var infoBoxW = infoBox.innerWidth();
	function showInfoBox(speed){
		var _speed = speed || 400;
		infoBox.stop().animate({'right': 0}, speed).removeClass('is-hidden');
	}
	function hideInfoBox(speed){
		var _speed = speed || 400;
		infoBox.stop().animate({'right': -infoBoxW}, speed).addClass('is-hidden');
	}
	jQuery('.info-close').on('click', hideInfoBox);
	jQuery('.info').on('click', showInfoBox);


	
	//set first slide 100% height
	jQuery(window).resize(adjustSlideResp);

	function adjustSlideResp(){
		var winH = jQuery(window).height();
		var winW = jQuery(window).width();
		if(winW>0)
		jQuery('.watch-intro, .table-cell, .text').css({'min-height': winH, 'height': winH});
	}
	adjustSlideResp();
      
      

   //jQuery('#owl-carousel, #owl-carousel2')

  // Moving Carousel IDS
  var owl = jQuery('#owl-carousel'); // Types of T-Shirts
  var owl2 = jQuery('#owl-carousel2'); // Style of T-Shirts
  var owl1 = jQuery('.owl-carousel1'); // Color of T-Shirts
  
  var owlOptions = {
    loop:true,
    /*margin:2,*/
    responsiveClass:true,
    lazyLoad : true,
	//autoplay:500,
  	//stopOnHover: true,
	dots:true,
	nav:false,
    callbacks: true,
    responsive:{
        0:{
            items:1,
            nav:false,
			dots:false
        },
		480:{
			items:2,
            nav:false,
			dots:false
		},
       600:{
            items:2,
            nav:false
			
        },
		992:{
		items:3,
		nav:false
		
		},
        1200:{
            items:4,
            nav:false,
            loop:true
        }

    }
};

    // Reload the carousel after loading new options  
  owl.owlCarousel(owlOptions);
  owl2.owlCarousel(owlOptions);
    
   customCheckboxOption("types[]"); //Checkbox click function for Types
   customCheckboxOption2("style[]");   //Checkbox click function for style
   customCheckboxOption3("color[]");   //Checkbox click function for color
   customCheckboxOption4("initials[]");  //Checkbox click function for initials
   customCheckboxOption3("size[]");  //Checkbox click function for size    
      
});

		/*jQuery(function(){
			jQuery('#camera_wrap_4').camera({
				height:'42%',
				pagination: 'false'
			});
		});*/


		jQuery(function(){
          jQuery('#maximage').maximage({
            cycleOptions: {
              fx: 'fade',
              speed: 1000 // Has to match the speed for CSS transitions in jQuery.maximage.css (lines 30 - 33)
            },
            onFirstImageLoaded: function(){
              jQuery('#cycle-loader').hide();
              jQuery('#maximage').fadeIn('fast');
            }
          });
          // To show it is dynamic html text
          jQuery('.in-slide-content').delay(1200).fadeIn();
		});





	// Home page Custom Code By SlopeMedia
    
	// This function is used when the customer clicks the Type Text box.
    function customCheckboxOption(checkboxName){

      var checkBox = jQuery('input[name="'+ checkboxName +'"]');
      jQuery(checkBox).each(function(){
        jQuery(this).parent().wrap( "<span class='custom-checkbox'></span>" );
        if(jQuery(this).is(':checked')){
          jQuery(this).parent().parent().addClass("selected");
        }
      });
      
      /* jQuery('#section1 .custom-checkbox').click(function(){
      	var chekEle = jQuery(this).find('label input:radio');
        //jQuery(chekEle).attr('checked', true);
      });*/   
     

      jQuery(checkBox).click(function(){

		// Create the Custom Shopify Text box based on the Selection By checkbox click.
        jQuery('input[name="'+ checkboxName +'"]').parent().parent().removeClass("selected");

        var selTypeValue = jQuery(this).val();
        var selVarientId = jQuery(this).attr('data-id');
        var repDropdown = jQuery('select#product-select');
        repDropdown.val(selVarientId);
       
        
        var alloptions = selTypeValue.split(' / ');
        var selOption1 = alloptions[0];
        var selOption2Arr = alloptions[1].split('|');
        var selOption3Arr = alloptions[2].split('|');

        var keyname = selOption1.toLowerCase().replace(" ", "_");

        var selCOption2 = [];
        var stringContent = '';
        
        
		// get the selection ofption type value from customer choice.
        jQuery('#txtTypes').attr("value", selOption1);

        // for load the selected option from the customer choice and get the images for next option load.
        for(var i=0; i<selOption2Arr.length; i++) {
          // check that selection option by customer not a plain. 
          if(selOption2Arr[i] != 'Plain' || selOption2Arr[i] != 'plain') {
            selCOption2[i, 'labelname'] = selOption2Arr[i];  // asign the selection label value to a variable.
            selCOption2[i, 'keyname'] = keyname+"_"+selOption2Arr[i].toLowerCase()+"_"+selOption3Arr[0].toLowerCase();   // set key for the next option load.
            // proJsonDetails is the shopify core JSON Data assign variable on header. that is load form Shopify Product JSON.
            for(var ifm = 0; ifm < proJsonDetails.images.length; ifm++) {   
              // check that image is present on that product data in the JSON
              if(proJsonDetails.images[ifm].indexOf(selCOption2[i, 'keyname']) > 0) {
                selCOption2[i, 'image'] = proJsonDetails.images[ifm];
                //selCOption2[i, 'price'] = proJsonDetails.price[ifm];
              }
            }
            // here collection of the next option with images.
            stringContent +='<li><a class="product-image" href="#"><img class="owl-lazy" data-src="'+selCOption2[i, "image"]+'" /></a><label><span class="custom-checkbox"><input type="radio" name="style[]" data-option="'+selTypeValue+'" value="'+selCOption2[i, "labelname"]+'"></span></label></li>';
          }
        }
        
        /* Initial image Generate Function */        
        var initialFrontImg = keyname+"_initial_back";
        var initialBackImg = keyname+"_initial_hands";
        var initialPlainImg = keyname+"_plain.";
        
        var initialhtml = '';
        var initialhtmlFrontContent = '';
        var initialhtmlBackContent = '';
        var initialhtmlPlainImgURL = '';
        
       
        for(var inm = 0; inm < proJsonDetails.images.length; inm++) {
          if(proJsonDetails.images[inm].indexOf(initialFrontImg) > 0) {
           	initialhtmlFrontContent = '<li><a class="product-image" href="#"><img src="'+proJsonDetails.images[inm]+'" /></a><div class="txtBoxinitial"><input type="text" id="initialFront" name="initialFront" size="3" value=""/></div><label><span class="custom-checkbox"><input type="checkbox" name="initials[]" value="Backside"></span></label></li>';
          }
          if(proJsonDetails.images[inm].indexOf(initialBackImg) > 0) {
            initialhtmlBackContent = '<li><a class="product-image" href="#"><img src="'+proJsonDetails.images[inm]+'" /></a><div class="txtBoxinitial"><input type="text" id="initialBack" name="initialBack" size="3" value="" /></div><label><span class="custom-checkbox"><input type="checkbox" name="initials[]" value="Hands"></span></label></li>';
          }
          
         
          if(proJsonDetails.images[inm].indexOf(initialPlainImg) > 0) {
           	initialhtmlPlainImgURL = proJsonDetails.images[inm];
          }
        }
        
        
        if(initialhtmlFrontContent !='') {
        	initialhtml += initialhtmlFrontContent;
      	}
        else {
         	initialhtml += '<li><a class="product-image" href="#"><img src="'+initialhtmlPlainImgURL+'" /></a><div class="txtBoxinitial"><input type="text" id="initialFront" name="initialFront" size="3" value=""/></div><label><span class="custom-checkbox"><input type="checkbox" name="initials[]" value="Backside"></span></label></li>';
        }
        if(initialhtmlBackContent !='') {
        	initialhtml += initialhtmlBackContent;
      	}
        else {
         	initialhtml += '<li><a class="product-image" href="#"><img src="'+initialhtmlPlainImgURL+'" /></a><div class="txtBoxinitial"><input type="text" id="initialBack" name="initialBack" size="3" value="" /></div><label><span class="custom-checkbox"><input type="checkbox" name="initials[]" value="Hands"></span></label></li>';
        }
        
        jQuery('#section4 ul.owl-carousel2').html(initialhtml);
        
        /* end of Initital image Generate function */
		
                            

        jQuery(this).parent().parent().toggleClass("selected");
        
        var owl = jQuery('#owl-carousel');  // T-Shirt Type Carousel
        var owl2 = jQuery('#owl-carousel2'); // T-Shirt Style Carousel
        var owl3 = jQuery('.owl-carousel2'); // T-Shirt Initial Carousel
        var owlOptions = {
            loop:true,
            /*margin:2,*/
            responsiveClass:true,
            lazyLoad : true,
            //autoplay:500,
            //stopOnHover: true,
            dots:true,
            nav:false,
            callbacks: true,
            responsive:{
                0:{
                    items:1,
                    nav:false,
                    dots:false
                },
                480:{
                     items:2,
                    nav:false,
                    dots:false
                },
               600:{
                    items:2,
                    nav:false

                },
                992:{
                items:3,
                nav:false

                },
                1200:{
                    items:4,
                    nav:false,
                    loop:true
                }

            }
        };

        
        owl.trigger('autoplay.stop.owl');

        // destroy default carousel
        owl2.trigger('destroy.owl.carousel');

        // update new options in the carousel
        owl2.html(stringContent);

		// Triggerback that carousel to move with the Newly Loaded option 
        owl2.owlCarousel(owlOptions); 
        owl2.trigger('initialize.owl.carousel');
		
        // Triggerback that carousel to move with the Newly Loaded option 
        owl3.owlCarousel(owlOptions);
        owl3.trigger('initialize.owl.carousel'); 
        
        var navLink = jQuery('#fp-nav li a.active');
        navLink.parent().next().find('a').trigger("click");

      });
    }


	// This function is used when the customer clicks the Style checkbox.
    function customCheckboxOption2(checkboxName){
      var checkBox = jQuery('input[name="'+ checkboxName +'"]');
      jQuery(checkBox).each(function(){
        jQuery(this).wrap( "<span class='custom-checkbox'></span>" );
        if(jQuery(this).is(':checked')){
          jQuery(this).parent().addClass("selected");
        }
      });

      jQuery(checkBox).live( "change", function() {
        jQuery('input[name="'+ checkboxName +'"]').parent().removeClass("selected");
        jQuery(this).parent().addClass("selected");

        var selOptionsValue = jQuery(this).attr('data-option');
        var selStyleValue = jQuery(this).val();

        var alloptions = selOptionsValue.split(' / ');
        var selOption1 = alloptions[0];
        var selOption2Arr = alloptions[1].split('|');
        var selOption3Arr = alloptions[2].split('|');

        var keyImgName = selOption1.toLowerCase().replace(" ", "_")+"_"+selStyleValue.toLowerCase();

        var stringContent = '';
        var searchColors = '';
        var imgLocation = '';

        jQuery('#txtStyle').attr("value", selStyleValue);

        for(var i = 0; i <selOption3Arr.length; i++) {
          searchColors = keyImgName+"_"+selOption3Arr[i].toLowerCase();
          for(var ifm = 0; ifm < proJsonDetails.images.length; ifm++) {
            if(proJsonDetails.images[ifm].indexOf(searchColors) > 0) {
              imgLocation = proJsonDetails.images[ifm];

            }
          }

          stringContent +='<li><a class="product-image" href="#"><img src="'+imgLocation+'" data-src="'+imgLocation+'" /></a><label><span class="custom-checkbox"><input type="radio" name="color[]" data-option="'+selOptionsValue+'" value="'+selOption3Arr[i]+'"></span></label></li>';

        }
        

        var owl = jQuery('#owl-carousel3');

        // destroy default carousel
        owl.trigger('destroy.owl.carousel');

        // update new elements in the carousel
        owl.html(stringContent);

		// Create options for new Carosel load
        owl.owlCarousel({							
          loop:false,
          responsiveClass:true,
           //lazyLoad:true,
    	   //loop:true,
          dots:true,
          //stopOnHover:true,
          nav:false,
          callbacks: true,
          responsive:{
            0:{
              items:1,
              nav:false,
              dots:false
            },
            480:{
              items:2,
              nav:false,
              dots:false
            },
            600:{
              items:2,
              nav:false

            },
            992:{
              items:3,
              nav:false

            },
            1200:{
              items:4,
              nav:false,
              loop:false
            }

          }
        });

		// Triggerback that carousel to move with the Newly Loaded option 
        owl.trigger('initialize.owl.carousel');
        
        var navLink = jQuery('#fp-nav li a.active');
        navLink.parent().next().find('a').trigger("click");

      });
    }

	// This function is used when the customer clicks the Initial checkbox.
    function customCheckboxOption4(checkboxName){

      var checkBox = jQuery('input[name="'+ checkboxName +'"]');
      jQuery(checkBox).each(function(){
        jQuery(this).wrap( "<span class='custom-checkbox'></span>" );
        if(jQuery(this).is(':checked')){
          jQuery(this).parent().addClass("selected");
        }
      });

      jQuery(checkBox).live("change", function() {

        //jQuery('input[name="'+ checkboxName +'"]').parent().removeClass("selected");
        //jQuery('input[name="'+ checkboxName +'"]:not(:checked)').removeClass("selected");
        
        if(jQuery(this).is(':checked')){
          jQuery(this).parent().addClass("selected");
          jQuery(this).parent().parent().parent().find('.txtBoxinitial').show();
        }
        if(!jQuery(this).is(':checked')){
          jQuery(this).parent().removeClass("selected");
          jQuery(this).parent().parent().parent().find('.txtBoxinitial').find('input').val('');
          jQuery(this).parent().parent().parent().find('.txtBoxinitial').hide();
        }
        
        var seloptionColor = jQuery(this).val();

        if(checkboxName == 'initials[]') {
          jQuery('#txtInitial_front').attr("value", jQuery('#initialFront').val());
          jQuery('#txtInitial_back').attr("value", jQuery('#initialBack').val());	
        }
        
        var navLink = jQuery('#fp-nav li a.active');
        //navLink.parent().next().find('a').trigger("click");

      });
      
      jQuery('.txtBoxinitial input').live("keyup", function() {
        	if(jQuery(this).attr("id")=='initialFront'){
				jQuery('#txtInitial_front').attr("value", jQuery(this).val());	
      		}
        	if(jQuery(this).attr("id")=='initialBack'){
				jQuery('#txtInitial_back').attr("value", jQuery(this).val());	
      		}
      });
      
      jQuery('.txtBoxinitial input').live("blur", function() {
        	if(jQuery(this).attr("id")=='initialFront'){
				var textFrontVal = jQuery('#txtInitial_front').attr("value");	
              if(textFrontVal != '') {
                 var navLink = jQuery('#fp-nav li a.active');
                 navLink.parent().next().find('a').trigger("click");
              }
      		}
        	if(jQuery(this).attr("id")=='initialBack'){
				jQuery('#txtInitial_back').attr("value", jQuery(this).val());
              var textFrontVal = jQuery('#txtInitial_front').attr("value");	
              if(textFrontVal != '') {
                 var navLink = jQuery('#fp-nav li a.active');
                 navLink.parent().next().find('a').trigger("click");
              }
      		}
      });

    }

	// This function is used when the customer clicks the Colour & Size checkbox.
	function customCheckboxOption3(checkboxName){

      var checkBox = jQuery('input[name="'+ checkboxName +'"]');
      jQuery(checkBox).each(function(){
        jQuery(this).wrap( "<span class='custom-checkbox'></span>" );
        if(jQuery(this).is(':checked')){
          jQuery(this).parent().addClass("selected");
        }
      });

      jQuery(checkBox).live("change", function() {

        jQuery('input[name="'+ checkboxName +'"]').parent().removeClass("selected");
        jQuery(this).parent().addClass("selected");

        var seloptionColor = jQuery(this).val();

        if(checkboxName == 'color[]') {
          jQuery('#txtColor').attr("value", seloptionColor);	
          var navLink = jQuery('#fp-nav li a.active');
          navLink.parent().next().find('a').trigger("click");
        }

        if(checkboxName == 'size[]') {
          jQuery('#txtSize').attr("value", seloptionColor);	
          jQuery( "#trigger-popup" ).trigger( "click" );
        }

      });

    }

	// Function for Final Add to Cart Popup function
	jQuery(function () {
	  jQuery('#trigger-popup').magnificPopup({
			type: 'inline',
			overflowY: 'auto',
	
			closeBtnInside: true,
			preloader: false,
			
			midClick: true,
			removalDelay: 300,
			mainClass: 'my-mfp-zoom-in',
			focus: '#add-to-cart',
			modal: true
		});
	  	// Close the Popup
		jQuery(document).on('click', '.modal-dismiss', function (e) {
			e.preventDefault();
			jQuery.magnificPopup.close();
		});
	});